import { render, staticRenderFns } from "./mfa.vue?vue&type=template&id=6d6a72e0&scoped=true"
import script from "./mfa.vue?vue&type=script&lang=js"
export * from "./mfa.vue?vue&type=script&lang=js"
import style0 from "./mfa.vue?vue&type=style&index=0&id=6d6a72e0&prod&scoped=true&lang=css"
import style1 from "./mfa.vue?vue&type=style&index=1&id=6d6a72e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a72e0",
  null
  
)

export default component.exports